import React from "react";
import _values from "lodash/values";
import { FacetType } from "shared-services";
import {
  FiltersFieldNames,
  IFilterFieldConfig,
  IFilterValues,
} from "../../types";
import {
  DropdownCheckbox,
  IDropdownCheckboxSearchInput,
} from "../../../../Molecules/DropdownCheckbox/DropdownCheckbox";
import { ICheckboxGroupValue } from "../../../CheckboxGroup/CheckboxGroup";
import { getCheckboxTags } from "../../helpers/getCheckboxTags";
import {
  facetToCheckboxOption,
  facetToCheckboxOptionWithStats,
} from "../../../../Functional/converters/facetConverter";
import AppearanceFilterDrawer from "./AppearanceFilterDrawer/AppearanceFilterDrawer";

export const appearanceFilterConfig: IFilterFieldConfig<IFilterValues> = {
  name: FiltersFieldNames.Appearance,
  facetNames: [FacetType.Appearance],
  defaultValue: {},
  modifiers: { showFilterControl: true },
  getFilterFiledProps: ({
    name,
    facetNames,
    values,
    filterDrawerValues,
    setFilterValues,
    setFilterDrawerValues,
    facets,
    modifiers,
    t,
    stats,
  }) => {
    const fieldValue = values[name] as ICheckboxGroupValue;
    const fieldFacets = (facetNames && facets[facetNames[0]]) || [];

    const fieldOptions = fieldFacets.map((facet) =>
      facetToCheckboxOptionWithStats(facet, stats?.appearances)
    );
    const filterDrawerValue = filterDrawerValues[name] as ICheckboxGroupValue;

    const filterTitle = t("common:label.appearance");
    const searchInputProps: IDropdownCheckboxSearchInput = {
      noResults: t("common:label.noResult"),
      placeholder: t("common:label.search"),
    };

    const filterControlComponent = modifiers?.showFilterControl ? (
      <DropdownCheckbox
        ValueComponent={DropdownCheckbox.getDefaultValueComponent({
          selectionPlaceholder: filterTitle,
          selectionPrefix: "",
        })}
        checkboxGroupConfig={{
          name,
          options: fieldOptions,
        }}
        value={values[name] as ICheckboxGroupValue}
        valueChanged={(value) => {
          setFilterValues({ [name]: value });
        }}
        searchInput={searchInputProps}
      />
    ) : null;

    const filterDrawerConfig = {
      title: filterTitle,
      id: FiltersFieldNames.Appearance,
      selected: _values(filterDrawerValue).some((v) => v),
      renderFilterContent: () => (
        <AppearanceFilterDrawer
          name={name}
          fieldOptions={fieldOptions}
          filterDrawerValue={filterDrawerValue}
          onSetFilterValues={setFilterDrawerValues}
        />
      ),
    };

    const tags = getCheckboxTags({
      t,
      name,
      fieldValue,
      fieldOptions: fieldFacets.map(facetToCheckboxOption),
      setFilterValues,
    });

    return {
      tags,
      filterDrawerConfig,
      filterControlComponent,
    };
  },
};
